
export enum MatterportTourStatus {
  IMPORTED = 1,
  ATTACHED = 2,
  DETACHED = 3
}